<template>
  <div>
    <div class="bg">
      <div class="flex">
        <el-image
            style="width: 66px;height:66px;margin-right: 12px"
            :src="defultImg"
        ></el-image>
        <div class="flex flex-column flex-around">
          <div>橙橙橙 131215528478</div>
          <div class="bq">管理员</div>
        </div>
      </div>
      <div class="item-center mt20">
        <div class="title">
          数据总览
        </div>
      </div>
      <div class="flex flex-between item-center mt20">
        <div v-for="(v, i) in titleList" :key="i" class="title-content item-center">
          <div class="flex">
            <div class="flex flex-center" style="width: 110px">
              <el-image
                  style="width: 66px;height:66px;"
                  :src="v.img"
              ></el-image>
            </div>
            <div class="flex flex-column flex-around">
              <div class="title-ms">{{ v.title }}</div>
              <div class="val-ms">{{ v.val }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hm-content class="mt10">
      <div class="flex flex-between item-center">
        <div class="title">
          数据趋势
        </div>
        <div class="title-ms">最近7天的统计数据（统计截止前一天）</div>
      </div>
      <div class="flex flex-end item-center mt10">
        <el-radio-group v-model="searchCondition.dateRaido" style="margin-right: 30px">
          <el-radio :label="1">昨天</el-radio>
          <el-radio :label="7">过去7天</el-radio>
          <el-radio :label="30">过去30天</el-radio>
        </el-radio-group>
        <el-date-picker
            v-model="searchCondition.dateList"
            type="daterange"
            size="small"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div>
        <div class="flex mt20">
          <div
              v-for="(v, i) in h"
              :key="i"
              @click="detail(i, v)"
              class="tab-btn text-center pointer"
          >
            <div class="hh" :style="{ background: v.background }"></div>
            <div
                class="p10"
                :style="{ background: activebtn === i ? v.rgba : '' }"
            >
              <div style="font-size: 14px">
                {{ v.name }}
              </div>
              <div style="font-weight: bold; font-size: 20px">
                {{ v.val }}
              </div>
            </div>
          </div>
        </div>
        <div style="height: 400px" v-show="optionLine.xAxis.data.length">
          <div
              v-if="showCanvas"
              id="mainline"
              style="height: 400px"
          ></div>
        </div>
        <div
            class="flex flex-center item-center gray"
            v-if="optionLine.xAxis.data.length === 0"
            style="height: 400px"
        >
          暂无人群行为统计数据
        </div>
      </div>
    </hm-content>
  </div>

</template>

<script>
import echarts from "echarts";

export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      defultImg:
          "https://imgcdn.hemiao100.com/ThemePictures/lQLPDhqq_2MDIS1UVLDUu8qI54PtpVFP5iyFUtKa_84_84.png_720x720q90g.jpg",
      titleList: [
        {
          title: "今日接待数",
          val: "987",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jiedaishu.png"
        },
        {
          title: "今日平均响应时长(秒)",
          val: "0.00",
          img: "https://imgcdn.hemiao100.com/ThemePictures/xiangyingshichang.png"
        },
        {
          title: "总接待数",
          val: "354",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jiedaishu.png"
        },
        {
          title: "总平均响应时长(秒)",
          val: "98674",
          img: "https://imgcdn.hemiao100.com/ThemePictures/xiangyingshichang.png"
        },
      ],
      h: [
        {
          name: "访问人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#B839F2",
          behaviorType: "visit",
          rgba:
              "linear-gradient(180deg, rgba(184, 57, 242, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "领券人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#F58D34",
          behaviorType: "getCoupon",

          rgba:
              "linear-gradient(180deg, rgba(245, 141, 52, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "加入购物车人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#16CEB9",
          behaviorType: "addCart",

          rgba:
              "linear-gradient(180deg, rgba(22, 206, 185, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "下单人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#0081E5",
          behaviorType: "prepay",
          rgba:
              "linear-gradient(180deg, rgba(0, 129, 229, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        },
        {
          name: "成交人数",
          val: 0,
          dateList: [],
          countList: [],
          background: "#F53489",
          behaviorType: "pay",

          rgba:
              "linear-gradient(180deg, rgba(245, 52, 137, 0.3) 0%, rgba(255, 255, 255, 0) 100%)"
        }
      ],
      activebtn: 0,
      optionLine: {
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                  "<br/>" +
                  params[i].marker +
                  // params[i].seriesName +
                  // " : " +
                  params[i].value +
                  "人";
            }
            return relVal;
          }
        },
        xAxis: {
          type: "category",
          data: [
             "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"
          ]
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        series: [
          {
            data: [
               820, 932, 901, 934, 1290, 1330, 1320
            ],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#B839F2"
                }
              }
            },
            areaStyle: {
              color: "#B839F2"
            }
          }
        ]
      },
      showCanvas: true
    };
  },
  created() {
    setTimeout(() => {
      let myChart = echarts.init(document.getElementById("mainline"));
      myChart.setOption(this.optionLine, true);
    }, 500);
  },
  mounted() {},
  methods: {
    detail(i, v) {
      this.showCanvas = false;
      setTimeout(() => {
        this.showCanvas = true;
      }, 0);

      this.activebtn = i;

      this.optionLine.series[0].itemStyle.normal.lineStyle.color = v.background;
      this.optionLine.series[0].areaStyle.color = v.background;
      this.searchCondition.behaviorType = v.behaviorType;
      this.optionLine.xAxis.data = v.dateList;
      this.optionLine.series[0].data = v.countList;
      if (v.dateList.length) {
        setTimeout(() => {
          let myChart = echarts.init(document.getElementById("mainline"));
          myChart.setOption(this.optionLine, true);
        }, 500);
      }

      // myChart.resize();

      // this.queryPhysiologicalBehaviorList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .desc {
    color: #999999;
    font-size: 14px;
  }
}
.bq {
  width: 48px;
  height: 22px;
  background: rgba(0, 129, 229, 0.1);
  border-radius: 2px;
  border: 1px solid #0081E5;
  color: #0081E5;
  text-align: center;
  line-height: 22px;
  font-size: 12px;
}
.title-content {
  width: 355px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
  border-radius: 6px;
  padding: 20px 10px;
  .title-ms {
    font-size: 14px;
  }
}
.title-ms {
  font-size: 14px;
  color: #999999;
}
</style>
